import { MetadataField } from '../models';

export const FileMetadataFields: MetadataField[] = [
  { key: 'title', label: 'files.detail.fileMetadata.fields.title' },
  { key: 'description', label: 'files.detail.fileMetadata.fields.description' },
  { key: 'resourceTypeGeneral', label: 'files.detail.fileMetadata.fields.resourceType' },
  { key: 'language', label: 'files.detail.fileMetadata.fields.resourceLanguage' },
];
